import moment from 'moment';
import * as queryString from 'query-string';
import { IToken } from '../models/IToken';

export default class ConnectionContext {
    private baseUrl: string;

    constructor(apiUrl: string) {
        this.baseUrl = apiUrl;
    }
    public async get(action: string): Promise<any> {
        try {
            let response: any = await fetch(this.baseUrl + action, {
                method: 'get',
                headers: this.setAuthToken({
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                })
            });
            if (response.status === 204 || response.status === 404) {
                return null;
            }
            if (response.ok) {
                return response.json();
            } else {
                throw null;
            }
        } catch (exception) {
            throw exception;
        }
    }

    public async post(action: string, body: {}): Promise<any> {
        try {

            let response: any = await fetch(this.baseUrl + action, {
                method: 'post',
                headers: this.setAuthToken({
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }),
                body: JSON.stringify(body)
            });
            if (response.status == 204) {
                return null;
            } else if (response.ok) {
                return response.json();
            }
            else {
                throw response.status;
            }
        } catch (exception) {
            throw exception;
        }
    }

    public async put(action: string, body: {}): Promise<any> {
        try {
            let response: any = await fetch(this.baseUrl + action, {
                method: 'put',
                headers: this.setAuthToken({
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }),
                body: JSON.stringify(body)
            });
            if (response.status == 204) {
                return null;
            }
            if (response.ok) {
                return response.json();
            } else {
                throw null;
            }
        } catch (exception) {
            throw exception;
        }
    }

    public async delete(action: string): Promise<any> {
        try {
            let response: any = await fetch(this.baseUrl + action, {
                method: 'delete',
                headers: this.setAuthToken({
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                })
            });
            if (response.status == 204) {
                return null;
            }
            if (response.ok) {
                return response.json();
            } else {
                throw null;
            }
        } catch (exception) {
            throw exception;
        }
    }

    public async login(username: string | undefined, password: string | undefined, captchaToken: string | undefined): Promise<boolean> {
        sessionStorage.removeItem('accessToken');
        sessionStorage.removeItem('tokenExpires');

        if (username === undefined) {
            return false;
        }

        if (password === undefined) {
            return false;
        }

        let user = {
            email: username,
            password: password,
            captchaToken: captchaToken
        }

        try {
            let response: any = await this.post("login", user);
            let expiresIn: number = moment().unix() + (response.expiresIn as number);

            sessionStorage.setItem('accessToken', response.accessToken);
            sessionStorage.setItem('expiresIn', expiresIn.toString());

            return true;
        } catch (exception) {
            return false;
        }
    }

    public async logout(): Promise<void> {
        await this.delete("Logout");

        sessionStorage.removeItem('accessToken');
        sessionStorage.removeItem('tokenExpires');
    }

    public getCurrentUserInformation(): IToken | null {
        let token: string | null = sessionStorage.getItem('accessToken');
        if (token === null) {
            return null;
        }
        let base64Url: string = token.split('.')[1];
        let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        let jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    }

    public getQueryStringByParameter(param: string): any {
        let parsed: queryString.ParseOptions = queryString.parse(window.location.search);
        return parsed[param];
    }

    public async checkRenewalToken(): Promise<boolean> {
        try {
            let response = await this.get('login');
            let expiresIn: number = moment().unix() + (response.expiresIn as number);

            sessionStorage.setItem('accessToken', response.accessToken);
            sessionStorage.setItem('expiresIn', expiresIn.toString());

            return true;
        } catch (error) {
            console.log('error', error);
        }
        return false;
    }

    private setAuthToken(headers: HeadersInit | undefined): HeadersInit | undefined {
        let accessToken: string | null = sessionStorage.getItem('accessToken');
        if (accessToken !== null) {
            if (headers === undefined) {
                headers = {};
            }

            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        return headers;
    }
}